export default [
    {
        id: 'washing',
        name: 'WASHING',
    },
    {
        id: 'cooking',
        name: 'COOKING',
    },
    {
        id: 'refrigerating',
        name: 'REFRIGERATING',
    },
    {
        id: 'beverage',
        name: 'BEVERAGE',
    },
    {
        id: 'ecosystem',
        name: 'ECOSYSTEM',
    },
    {
        id: 'home_organization',
        name: 'HOME_ORGANIZATION',
    },
];
